import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {LfRoutes} from '@lightweightform/core';


const routes: LfRoutes = [
  {
    path: 'union',
    loadChildren: () => import('./union/app.module').then(m => m.UnionFormModule)
  },
  {
    path: 'non-union',
    loadChildren: () => import('./non-union/app.module').then(m => m.NonUnionFormModule)
  },
  {
    path: 'import',
    loadChildren: () => import('./import/app.module').then(m => m.ImportFormModule)
  },
  {
    path: 'intermediary',
    loadChildren: () => import('./intermediary/app.module').then(m => m.IntermediaryFormModule)
  },
  {path: '', children: []}

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RegistoFormsRoutingModule {
}
